export default "__VITE_ASSET__Jyolj6tn__"